import { render } from "./ModalProfPlacePayMethod.vue?vue&type=template&id=6c60fbf2"
import script from "./ModalProfPlacePayMethod.vue?vue&type=script&lang=js"
export * from "./ModalProfPlacePayMethod.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__